import React, { useEffect, useState } from 'react'
import Address from './SubTab/Address'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import AddTransport from './AddEdit/AddTransport';
import EditTransport from './AddEdit/EditTransport';
import { useDispatch, useSelector } from 'react-redux';
import { getJobOrderCFSList, getJobOrderCustomerList, getJobOrderTransportList } from '../../../../../Redux/action/Joborder/JoborderAction';
import { BeatLoader } from 'react-spinners';

const TransportTab = ({ token, user_id, b64id, transmode, transtype }) => {

    const dispatch = useDispatch();

    const [transportList, setTransportList] = useState([]);
    const [transport_id, setTransport_id] = useState(0);

    const [showLoader, setShowLoader] = useState(true);

    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (id) => {
        setShowEdit(true);
        if (id) {
            setTransport_id(id);
        }
    }


    //dispatch
    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderCFSList(token, user_id));
            dispatch(getJobOrderCustomerList(token, user_id));

            let id = atob(b64id);
            if (id) {
                dispatch(getJobOrderTransportList(token, user_id, id));
            }
        }
    }, [token, user_id]);

    const refreshTransport = () => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getJobOrderTransportList(token, user_id, id));
            }
        }
    }





    const {
        //list job order cfs
        loadingJobOrderCFSList,
        JobOrderCFSListError,
        JobOrderCFSList,


        //organisation list
        loadingJobOrderCustomerList,
        JobOrderCustomerList,
        JobOrderCustomerListError,

        loadingJobOrderTransportList,
        JobOrderTransportList,
        JobOrderTransportListError,
    } = useSelector(state => state?.JoborderReducer);


    useEffect(() => {
        if (loadingJobOrderTransportList) {
            setShowLoader(true)
        } else {
            setShowLoader(false);
        }

        if (JobOrderTransportList) {
            setTransportList(JobOrderTransportList);
        }

    }, [loadingJobOrderTransportList, JobOrderTransportList])



    return (
        <>
            {
                showLoader ?
                    <BeatLoader />
                    :
                    <>
                        <div className="row border-bottom-2 pb-3">
                            <div className="col-md-12">
                                <div className="card px-3 py-2">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">

                                        </div>
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                                            <a className="btn btn-light me-2">Clear</a>
                                            <div className="btn btn-primary cursor-pointer me-2" onClick={handleShowAdd}>
                                                <i className="ti ti-square-rounded-plus me-2" />
                                                Add Transport
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="table-responsive">
                                        <table className="table table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <th scope="col">S. No.</th>
                                                    <th scope="col">Pickup address</th>
                                                    {/* <th scope="col">Empty Container Pickup</th> */}
                                                    <th scope="col">Transporter</th>
                                                    <th scope="col">Delivery Address</th>
                                                    <th scope="col">Packages</th>
                                                    <th scope="col">Gross Wt</th>
                                                    <th scope="col">Trans ref No</th>
                                                    <th scope="col">Remarks</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    transportList?.map((val, index) => {
                                                        return <tr>
                                                            <th scope="col">{index + 1}</th>
                                                            <th scope="col">{val?.pickup_address}</th>
                                                            <th scope="col">{val?.transporter_branch_address ?? ""}</th>
                                                            <th scope="col">{val?.deliver_address}</th>
                                                            <th scope="col">{val?.total_package}</th>
                                                            <th scope="col">{val?.total_weight}</th>
                                                            <th scope="col">{val?.transporter_ref_no}</th>
                                                            <th scope="col">{val?.remark}</th>
                                                            <th scope="col">
                                                                <div className="dropdown table-action">
                                                                    <a
                                                                        className="action-icon"
                                                                        data-bs-toggle="dropdown"
                                                                    // href="/flexichain/airline"
                                                                    >
                                                                        <i className="fa fa-ellipsis-v" />
                                                                    </a>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <div className="dropdown-item cursor-pointer" onClick={() => handleShowEdit(val.id)}>
                                                                            <i className="ti ti-edit text-blue me-2" /> Edit
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <AddTransport
                            showAdd={showAdd}
                            handleCloseAdd={handleCloseAdd}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            transmode={transmode}
                            transtype={transtype}
                            loadingJobOrderCFSList={loadingJobOrderCFSList}
                            JobOrderCFSListError={JobOrderCFSListError}
                            JobOrderCFSList={JobOrderCFSList}
                            loadingJobOrderCustomerList={loadingJobOrderCustomerList}
                            JobOrderCustomerList={JobOrderCustomerList}
                            JobOrderCustomerListError={JobOrderCustomerListError}
                            refreshTransport={refreshTransport}
                        />


                        <EditTransport
                            showAdd={showEdit}
                            handleCloseAdd={handleCloseEdit}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            transmode={transmode}
                            transtype={transtype}
                            loadingJobOrderCFSList={loadingJobOrderCFSList}
                            JobOrderCFSListError={JobOrderCFSListError}
                            JobOrderCFSList={JobOrderCFSList}
                            loadingJobOrderCustomerList={loadingJobOrderCustomerList}
                            JobOrderCustomerList={JobOrderCustomerList}
                            JobOrderCustomerListError={JobOrderCustomerListError}
                            refreshTransport={refreshTransport}
                            transport_id={transport_id}
                        />

                    </>
            }
        </>


    )
}

export default TransportTab